import React from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'

import styles from './styles.module.scss'

export interface MarketingPillProps {
  text: React.ReactNode
}

const MarketingPill = ({ text }: MarketingPillProps) => {
  const [getClassName, makeTestId] = useNameFormatter('MarketingPill')

  return (
    <div
      className={styles[getClassName('')]}
      data-testid={makeTestId('')}
    >
      {text}
    </div>
  )
}

export default MarketingPill
